/**
 * TackAction
 * 
 * @Author: Focci
 * @Date: 2023-09-20 15:53:03
 * @Last Modified by: Focci
 * @Last Modified time: 2023-09-20 15:53:03
 */

// import PropTypes from 'prop-types'
import useProgressRouter from '@hook/useProgressRouter'
import { myClaim } from '@lib/route/profile'
import { propertyDetail } from '@lib/route/house'
import { useLocale, useTranslations } from 'next-intl'
import { useCallback } from 'react'
import { Button } from '@comp/material'

export default function TackAction({ 
  property,
  hideViewButton
}) {
  const locale = useLocale()
  const tt = useTranslations('track')
  const { routerPush } = useProgressRouter()

  const handleSubmit = useCallback((type) => {
    if(type === 'detail') {
      routerPush(propertyDetail(property.slug, locale))
    } else if(type === 'list') {
      routerPush(myClaim(locale))
    }
  }, [property.slug, routerPush, locale])

  return (
    <div className="mt-12 mb-6 flex items-center justify-center gap-4">
      {!hideViewButton && (
        <Button 
          size="large" 
          color="primary"
          onClick={() => handleSubmit('detail')}
        >
          {tt('viewPropertyDetail')}
        </Button>
      )}
      <Button 
        size="large" 
        color="primary"
        variant="outlined"
        onClick={() => handleSubmit('list')}
      >
        {tt('toMyTrackedLists')}
      </Button>
    </div>
  )
}

// TackAction.propTypes = {
//   className: PropTypes.string,
// }
